export default __webpack_public_path__ + "static/media/electricopalmantiswebsite_98ee5cbb755c3a0bf1fa47d026e81717.afddfcfd.png";